module.exports = __webpack_public_path__ + "static/media/handshake.87cbd0d8.svg";